/**
 * AuthErrorHandler - Handles authentication-related errors from URL parameters
 * Used when OAuth flows redirect back with error states
 */

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// ============================================================================
// Component
// ============================================================================

export const AuthErrorHandler: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const error = searchParams.get('error');
    const email = searchParams.get('email');

    if (error) {
      switch (error) {
        case 'unverified_account':
          toast.error(
            `Debes verificar tu email (${email}) antes de usar Google OAuth. Revisa tu bandeja de entrada y completa la verificación.`,
            {
              duration: 8000,
              icon: '🔒',
            },
          );
          break;

        case 'account_conflict':
          toast.error(
            'Ya existe una cuenta con este email. Usa tu contraseña existente o vincúlalas en la configuración.',
            {
              duration: 6000,
              icon: '⚠️',
            },
          );
          break;

        case 'linking_failed':
          toast.error(
            'No se pudo vincular las cuentas. Intenta de nuevo o contacta soporte.',
            {
              duration: 5000,
              icon: '❌',
            },
          );
          break;

        default:
          toast.error('Error de autenticación. Intenta de nuevo.', {
            duration: 4000,
          });
      }

      // Clear error parameters from URL
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('error');
      newSearchParams.delete('email');
      setSearchParams(newSearchParams, { replace: true });

      // Redirect to login after showing error
      setTimeout(() => {
        navigate('/auth/login', { replace: true });
      }, 1000);
    }
  }, [navigate, searchParams, setSearchParams]);

  return null; // This component doesn't render anything visible
};

export default AuthErrorHandler;
